import React from "react";
import AdminTrialControl from "../components/admin/trials/AdminTrialControl";
const Trials = () => {
    return React.createElement(AdminTrialControl, null);
};
export default Trials;
